import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resolve } from '@angular/router';
import { AuthService } from '../auth/auth.service'
import { ProfileService, UserProfile } from '../profile/profile.service'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthResolverService implements Resolve<Observable<UserProfile>> {

  constructor(private http: HttpClient,
    private authService: AuthService,
    private profileService: ProfileService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserProfile> {

    return this.profileService.load();

  }

}
